/* eslint-disable react/prop-types */
import { ReactComponent as ShipAidMark } from '../assets/icons/ShipAid.svg';
import classes from '../modulecss/trackingFooter.module.css';

/**
 * ShipAid attribution on the shopper-facing portal.
 *
 * Always ShipAid branding — a merchant's own logo belongs in the page header,
 * which they set through the tracking page editor.
 */
const TrackingFooter = ({ isHomePage = false }) => {
  return (
    <div className={isHomePage ? classes.containerHomePage : classes.container}>
      <span
        className="inline-flex items-center gap-2 text-[#0b1c30]"
        aria-label="ShipAid"
      >
        <ShipAidMark className="w-7" />
        <span className="font-bold text-sm tracking-tight">SHIPAID</span>
      </span>
    </div>
  );
};

export default TrackingFooter;
